import _taggedTemplateLiteral from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
var variants = {
  regular: {
    width: 180
  },
  large: {
    width: 215
  }
};
export var Button = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none;\n  background: none;\n  width: 35px;\n  height: 35px;\n  padding: 0;\n  margin: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  position: relative;\n\n  &[aria-expanded='true'] {\n    opacity: 0.5;\n  }\n"])));
export var OptionsContainer = styled.ul(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", "px;\n  display: flex;\n  align-items: flex-start;\n  padding: 0;\n  flex-direction: column;\n  overflow: hidden;\n  margin: 0;\n"])), function (props) {
  return variants[props.variant].width;
});